import { Col, Row, Typography } from 'antd';
import ApplicationSubHeading from '@/components/Elements/Heading/ApplicationSubHeading';
import { useFetchUserDataQuery } from '@/store/apis/userApi';
import { useEffect, useState } from 'react';
import Meeting from '@/components/Meeting/Meeting';

export const TaxAdvicePage = () => {
  const { data: userProfileData, refetch } = useFetchUserDataQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const userProfile = userProfileData?.data;
  const [meetingUrl, setMeetingUrl] = useState<string>('');
  useEffect(() => {
    if (!userProfile) return;
    const params = new URLSearchParams({
      embed: 'true',
      ...(userProfile?.firstName && { firstname: userProfile?.firstName }),
      ...(userProfile?.lastName && { lastname: userProfile?.lastName }),
      ...(userProfile?.email && { email: userProfile?.email }),
      ...(userProfile?.phone && { phone: userProfile?.phone }),
    });
    setMeetingUrl(
      `https://meetings.hubspot.com/pau-lam/tax-consultation?${params}`,
    );
  }, [userProfile]);

  return (
    <div
      style={{
        margin: '0 auto',
        marginTop: '20px',
      }}
    >
      <Row>
        <Col xs={12}>
          <Meeting meetingUrl={meetingUrl} title="Book a Meeting" />
        </Col>
      </Row>
    </div>
  );
};

export default TaxAdvicePage;
